import { useCallback } from 'react';
import type { ElasticRetailer } from '@//app/api/retailers/[slug]';
import { useLegacyTracking } from '@//providers/LegacyTrackingProvider';
import type { LegacyTrackPhoneNumberVisibleRetailerEventData } from './legacy-types';
import { mapElasticBranchToLegacyItem } from './utils';

export const createLegacyTrackPhoneNumberVisibleRetailer = (
  branch: ElasticRetailer,
): LegacyTrackPhoneNumberVisibleRetailerEventData => {
  const eventData: LegacyTrackPhoneNumberVisibleRetailerEventData = {
    eventType: 'conversion',
    conversionType: 'phonenumber-visible-retailer',
    item: mapElasticBranchToLegacyItem(branch),
    pageType: 'dealer page',
  };

  return eventData;
};

export const useLegacyTrackPhoneNumberVisibleRetailer = () => {
  const { track } = useLegacyTracking();

  const trackLegacyTrackPhoneNumberVisibleRetailer = useCallback(
    (branch: ElasticRetailer) => {
      // Track event with only the event-specific data
      // The provider will inject base data (source, url, eventTimestamp, userData)
      track({
        event: 'conversion',
        data: createLegacyTrackPhoneNumberVisibleRetailer(branch),
      });
    },
    [track],
  );

  return {
    trackLegacyTrackPhoneNumberVisibleRetailer,
  };
};
